import { handleActions } from 'redux-actions'

import { deletePatientData } from 'src/store/modules/actionCreators'
import {
  setAddresses,
  setAlertNote,
  setAssignedCaregivers,
  setAvailableCaregivers,
  setPatientAlertNote,
  setPatientAllergies,
  setPatientEvents,
  setPhones
} from 'src/store/modules/patient/demographics'

const initialState = {
  phones: [],
  emails: [],
  addresses: [],
  emergencyContacts: [],
  professionalTeam: [],
  pharmacies: [],
  allergies: [],
  events: [],
  assignedCaregivers: [],
  availableCaregivers: [],
  patientAlertNote: {},
  patientMedicalEquipment: []
}

export default handleActions(
  {
    [setAlertNote](state, { payload }) {
      return {
        ...state,
        patientAlertNote: {
          ...state.patientAlertNote,
          ...payload
        }
      }
    },

    [setPhones](state, { payload: phones }) {
      return {
        ...state,
        phones
      }
    },

    [setAddresses](state, { payload: addresses }) {
      return {
        ...state,
        addresses
      }
    },

    [setPatientAllergies](state, { payload: allergies }) {
      return {
        ...state,
        allergies
      }
    },

    [setPatientEvents](state, { payload: events }) {
      return {
        ...state,
        events
      }
    },

    [setAssignedCaregivers](state, { payload: assignedCaregivers }) {
      return {
        ...state,
        assignedCaregivers
      }
    },

    [setAvailableCaregivers](state, { payload: availableCaregivers }) {
      return {
        ...state,
        availableCaregivers
      }
    },

    [setPatientAlertNote](state, { payload: patientAlertNote }) {
      return {
        ...state,
        patientAlertNote
      }
    },

    [deletePatientData]() {
      return initialState
    }
  },
  initialState
)
